/*
 * godard-a11y.js
 * Accessible-name repair for quantity inputs.
 *
 * PageSpeed "Agentic Browsing" -> "Accessibility tree is not well-formed"
 * fails the product page on axe rule `label`, sub-check `hidden-explicit-label`:
 * the quantity <input> inside .price-per-item__container is associated with a
 * <label for> whose text is visually hidden, so the input has no usable
 * accessible name for assistive tech or AI agents.
 *
 * We copy the label's own text onto the input as aria-label (falling back to
 * "Quantity"), which satisfies the rule without changing anything visually.
 * Idempotent, runs once on DOMContentLoaded plus on variant re-renders.
 */
(function () {
  'use strict';

  var SELECTOR = 'input.quantity__input, quantity-input input[type="number"]';

  function labelTextFor(el) {
    var text = '';
    try {
      if (el.id && window.CSS && typeof CSS.escape === 'function') {
        var explicit = document.querySelector('label[for="' + CSS.escape(el.id) + '"]');
        if (explicit) text = explicit.textContent || '';
      }
      if (!text) {
        var wrapping = el.closest ? el.closest('label') : null;
        if (wrapping) text = wrapping.textContent || '';
      }
    } catch (e) {
      text = '';
    }
    /* Collapse whitespace and drop the live "(n in cart)" counter so the
       accessible name stays stable as the cart changes. */
    text = String(text).replace(/\([^)]*in cart[^)]*\)/gi, ' ').replace(/\s+/g, ' ').trim();
    return text;
  }

  function repair() {
    var nodes = document.querySelectorAll(SELECTOR);
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (el.getAttribute('aria-label') || el.getAttribute('aria-labelledby')) continue;
      el.setAttribute('aria-label', labelTextFor(el) || 'Quantity');
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', repair, { once: true });
  } else {
    repair();
  }

  /* Dawn re-renders the buy-box on variant change; re-apply cheaply. */
  document.addEventListener('variant:update', repair);
  if (typeof window.requestIdleCallback === 'function') {
    window.requestIdleCallback(repair, { timeout: 3000 });
  } else {
    setTimeout(repair, 1200);
  }
})();
